// 小狗看番 - 番剧推荐内容数据

export interface AnimeItem {
  id: string;
  title: string;
  subtitle: string;
  rating: number;
  category: string;
  tags: string[];
  episodes: string;
  status: string;
  cover: string;
  desc: string;
}

export const categoryTabs = ["全部神番", "搞笑番", "沙雕动画", "解压日常", "治愈番"];

export const animeList: AnimeItem[] = [
  {
    id: "anime-01",
    title: "今天也要摸鱼到下班",
    subtitle: "办公室摆烂日常",
    rating: 9.6,
    category: "搞笑番",
    tags: ["职场", "下饭", "摸鱼"],
    episodes: "全12话",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Cartoon%20office%20comedy%20anime%20scene%2C%20a%20cheerful%20young%20man%20in%20loose%20suit%20lazily%20slouching%20at%20a%20desk%20with%20a%20rice%20ball%2C%20warm%20orange%20background%2C%20flat%20vector%20style%2C%20playful%20facial%20expression%2C%20cute%20dog%20mascot%20peeking%2C%20soft%20lighting%2C%20funny%20and%20relaxed%20mood&width=600&height=800&seq=xgkp-cover-01&orientation=portrait",
    desc: "社畜小林每天最大的心愿就是准点下班。在老板眼皮底下疯狂摸鱼，把摸鱼哲学玩出花来，每一集都笑到打滚的下饭神番。",
  },
  {
    id: "anime-02",
    title: "社畜的干饭日记",
    subtitle: "干饭人干饭魂",
    rating: 9.4,
    category: "解压日常",
    tags: ["美食", "干饭", "解压"],
    episodes: "全24话",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20anime%20girl%20happily%20eating%20a%20huge%20bowl%20of%20ramen%20with%20chopsticks%2C%20steam%20rising%2C%20warm%20golden%20background%2C%20flat%20vector%20illustration%2C%20joyful%20expression%2C%20cozy%20and%20satisfying%20mood%2C%20soft%20studio%20lighting&width=600&height=800&seq=xgkp-cover-02&orientation=portrait",
    desc: "干饭人本饭！把每一顿饭都吃出仪式感，用美食治愈一天疲惫。看一集饿一集，吃饭配这番真的绝了。",
  },
  {
    id: "anime-03",
    title: "转生成为沙雕网友",
    subtitle: "无厘头异世界",
    rating: 9.3,
    category: "沙雕动画",
    tags: ["异世界", "无厘头", "弹幕"],
    episodes: "全12话",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20cartoon%20anime%20character%20with%20crazy%20hair%20holding%20a%20phone%20reborn%20in%20a%20bright%20colorful%20fantasy%20world%2C%20floating%20comic%20speech%20bubbles%2C%20flat%20vector%20style%2C%20vivid%20orange%20and%20teal%20palette%2C%20playful%20and%20absurd%20mood&width=600&height=800&seq=xgkp-cover-03&orientation=portrait",
    desc: "一觉醒来穿成异世界的普通村民，结果全村都是沙雕网友。全员戏精上头，弹幕比剧情还精彩，笑得停不下来。",
  },
  {
    id: "anime-04",
    title: "我家狗子会吐槽",
    subtitle: "萌宠治愈日常",
    rating: 9.5,
    category: "治愈番",
    tags: ["萌宠", "治愈", "吐槽"],
    episodes: "全16话",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Adorable%20cartoon%20dog%20wearing%20glasses%20sitting%20on%20a%20sofa%20with%20a%20sassy%20expression%2C%20comic%20speech%20bubble%20overhead%2C%20warm%20cream%20and%20orange%20background%2C%20flat%20vector%20illustration%2C%20heartwarming%20and%20funny%20mood%2C%20soft%20lighting&width=600&height=800&seq=xgkp-cover-04&orientation=portrait",
    desc: "表面是呆萌小狗，其实是吐槽役担当。每天精准吐槽主人的迷惑行为，萌宠与毒舌的反差萌，治愈又爆笑。",
  },
  {
    id: "anime-05",
    title: "勇者被迫去摆烂",
    subtitle: "反套路冒险日常",
    rating: 9.1,
    category: "沙雕动画",
    tags: ["冒险", "反套路", "摆烂"],
    episodes: "全13话",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Cartoon%20anime%20hero%20in%20armor%20lying%20on%20a%20hammock%20with%20a%20lazy%20grin%2C%20a%20dragon%20sleeping%20in%20background%2C%20warm%20sunset%20orange%20palette%2C%20flat%20vector%20style%2C%20comedy%20adventure%20mood%2C%20playful%20and%20chill%20atmosphere&width=600&height=800&seq=xgkp-cover-05&orientation=portrait",
    desc: "被召唤去讨伐魔王的勇者只想躺平。用摆烂和摸鱼重新定义冒险，看反派和勇者谁先破防，全程笑点密集。",
  },
  {
    id: "anime-06",
    title: "隔壁社团是戏精",
    subtitle: "校园沙雕群像",
    rating: 9.2,
    category: "搞笑番",
    tags: ["校园", "群像", "社团"],
    episodes: "全12话",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Group%20of%20lively%20cartoon%20high%20school%20students%20in%20a%20club%20room%20posing%20dramatically%2C%20bright%20warm%20background%2C%20flat%20vector%20comedy%20anime%20style%2C%20exaggerated%20expressions%2C%20energetic%20and%20funny%20mood%2C%20soft%20lighting&width=600&height=800&seq=xgkp-cover-06&orientation=portrait",
    desc: "一个全员戏精的奇怪社团，每天都在上演大型表演。你以为他们在正经搞社团，其实在整活，搞笑群像笑到缺氧。",
  },
  {
    id: "anime-07",
    title: "女仆与咸鱼主人",
    subtitle: "反差日常喜剧",
    rating: 9.0,
    category: "解压日常",
    tags: ["日常", "反差", "吐槽"],
    episodes: "全11话",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Cartoon%20maid%20girl%20holding%20a%20tray%20staring%20exasperated%20at%20a%20lazy%20young%20man%20on%20a%20couch%20eating%20chips%2C%20warm%20cozy%20room%2C%20flat%20vector%20comedy%20anime%2C%20warm%20orange%20and%20cream%20palette%2C%20funny%20contrast%2C%20soft%20lighting&width=600&height=800&seq=xgkp-cover-07&orientation=portrait",
    desc: "万能女仆遇上全屋最咸鱼的懒主人。一个拼命干活，一个拼命偷懒，反差日常笑点不断，解压必备。",
  },
  {
    id: "anime-08",
    title: "史上最惨反派养成记",
    subtitle: "反派求生喜剧",
    rating: 8.9,
    category: "沙雕动画",
    tags: ["反派", "求生", "搞笑"],
    episodes: "全15话",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Comical%20cartoon%20villain%20in%20dramatic%20cape%20slipping%20on%20a%20banana%20peel%2C%20confused%20expression%2C%20warm%20orange%20background%2C%20flat%20vector%20comedy%20anime%20style%2C%20absurd%20and%20funny%20mood%2C%20soft%20lighting&width=600&height=800&seq=xgkp-cover-08&orientation=portrait",
    desc: "立志成为最强反派，结果每次计划都翻车。史上最惨反派求生记，把倒霉演成艺术，笑点拉满。",
  },
];

export interface NewSeasonItem {
  id: string;
  title: string;
  tag: string;
  ep: string;
  updateDay: string;
  cover: string;
}

export const newSeasonList: NewSeasonItem[] = [
  {
    id: "ns-01",
    title: "周五的快乐源泉",
    tag: "新番",
    ep: "第3话",
    updateDay: "每周五更新",
    cover: "https://readdy.ai/api/search-image?query=Cartoon%20anime%20scene%20of%20happy%20friends%20eating%20snacks%20and%20laughing%20in%20front%20of%20a%20TV%2C%20warm%20evening%20light%2C%20flat%20vector%20comedy%20style%2C%20cozy%20fun%20atmosphere%2C%20orange%20and%20teal%20palette&width=800&height=600&seq=xgkp-new-01&orientation=landscape",
  },
  {
    id: "ns-02",
    title: "打工人的第二人格",
    tag: "沙雕",
    ep: "第5话",
    updateDay: "每周三更新",
    cover: "https://readdy.ai/api/search-image?query=Cartoon%20anime%20office%20worker%20with%20two%20split%20personalities%20arguing%20with%20himself%2C%20split%20screen%20style%2C%20warm%20orange%20background%2C%20flat%20vector%20comedy%2C%20absurd%20and%20funny%20mood&width=800&height=600&seq=xgkp-new-02&orientation=landscape",
  },
  {
    id: "ns-03",
    title: "病友会全员卧龙凤雏",
    tag: "群像",
    ep: "第2话",
    updateDay: "每周二更新",
    cover: "https://readdy.ai/api/search-image?query=Cartoon%20anime%20group%20of%20quirky%20patients%20in%20a%20hospital%20waiting%20room%20playing%20cards%20and%20laughing%2C%20bright%20warm%20setting%2C%20flat%20vector%20comedy%20style%2C%20lighthearted%20and%20funny&width=800&height=600&seq=xgkp-new-03&orientation=landscape",
  },
  {
    id: "ns-04",
    title: "我和外卖小哥的双向奔赴",
    tag: "日常",
    ep: "第6话",
    updateDay: "每周日更新",
    cover: "https://readdy.ai/api/search-image?query=Cartoon%20anime%20delivery%20rider%20handing%20food%20to%20an%20excited%20hungry%20girl%20at%20a%20door%2C%20warm%20golden%20light%2C%20flat%20vector%20comedy%20slice%20of%20life%2C%20cozy%20and%20amusing%20mood&width=800&height=600&seq=xgkp-new-04&orientation=landscape",
  },
];

export interface ReviewItem {
  id: string;
  name: string;
  role: string;
  avatar: string;
  text: string;
  rating: number;
}

export const reviewList: ReviewItem[] = [
  {
    id: "rv-01",
    name: "一只咸鱼喵",
    role: "干饭达人",
    avatar: "https://readdy.ai/api/search-image?query=Round%20cute%20cartoon%20cat%20avatar%20with%20warm%20orange%20background%2C%20flat%20vector%20style%2C%20friendly%20smile%2C%20minimal&width=200&height=200&seq=xgkp-av-01&orientation=squarish",
    text: "以前吃饭总是找不到下饭番，自从看了小狗看番，每顿都吃出幸福感！推荐的沙雕动画真的每集都能笑出声。",
    rating: 5,
  },
  {
    id: "rv-02",
    name: "摸鱼侠本侠",
    role: "996打工人",
    avatar: "https://readdy.ai/api/search-image?query=Round%20cute%20cartoon%20panda%20avatar%20with%20teal%20background%2C%20flat%20vector%20style%2C%20chill%20expression%2C%20minimal&width=200&height=200&seq=xgkp-av-02&orientation=squarish",
    text: "上班摸鱼必备！解压日常真的治好了我的精神内耗，看完心情瞬间变好，推荐列表也太懂我了。",
    rating: 5,
  },
  {
    id: "rv-03",
    name: "咕咕咕本咕",
    role: "追番重症患者",
    avatar: "https://readdy.ai/api/search-image?query=Round%20cute%20cartoon%20bird%20avatar%20with%20yellow%20background%2C%20flat%20vector%20style%2C%20happy%20expression%2C%20minimal&width=200&height=200&seq=xgkp-av-03&orientation=squarish",
    text: "搞笑番和沙雕动画的分类特别清晰，按心情选番太方便了。每一部都是宝藏，安利给我整个追番群。",
    rating: 5,
  },
];

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    id: "faq-01",
    question: "小狗看番是什么？",
    answer: "小狗看番是一个专注搞笑番剧、沙雕动画和解压爆笑日常的聚合推荐站。我们把好笑的、下饭的、解压的神番都集中起来，让你打开就能找到想看的，不费脑只乐呵。",
  },
  {
    id: "faq-02",
    question: "这里的番剧都是正版免费看吗？",
    answer: "小狗看番专注于番剧推荐和盘点，帮助你快速找到对味的内容。观看平台和版权信息以各正版平台标注为准，我们只负责帮你把最好笑的神番挑出来。",
  },
  {
    id: "faq-03",
    question: "什么是下饭神番？",
    answer: "下饭神番就是那种不烧脑、节奏轻快、边吃饭边看特别过瘾的番剧。小狗看番的下饭神番合集，专门收录这类无脑乐呵、每集都有笑点的内容，吃饭追番两不误。",
  },
  {
    id: "faq-04",
    question: "更新频率是多久？",
    answer: "我们每周都会上新番速递和沙雕动画盘点，紧跟当季搞笑番的热度，保证你看的都是新鲜又好笑的神番，追更更方便。",
  },
  {
    id: "faq-05",
    question: "怎么快速找到适合我的番？",
    answer: "你可以通过主题分类（搞笑番、沙雕动画、解压日常、治愈番）或顶部搜索框快速筛选。评分和标签能帮你一眼锁定符合口味的下饭神番。",
  },
];

export const categoryCards = [
  {
    key: "搞笑番",
    title: "搞笑番",
    desc: "正经喜剧番，笑点密集不冷场，剧情和搞笑双在线，追完还想二刷的下饭神番。",
    icon: "ri-emotion-laugh-line",
    img: "https://readdy.ai/api/search-image?query=Cartoon%20anime%20characters%20laughing%20hysterically%20together%2C%20bright%20warm%20orange%20background%2C%20flat%20vector%20comedy%20style%2C%20joyful%20and%20energetic%20mood%2C%20soft%20lighting&width=800&height=600&seq=xgkp-cat-01&orientation=landscape",
  },
  {
    key: "沙雕动画",
    title: "沙雕动画",
    desc: "无厘头到没朋友，脑洞大开的整活神作，全程高能反转，笑到肚子疼的爆笑日常。",
    icon: "ri-lightbulb-flash-line",
    img: "https://readdy.ai/api/search-image?query=Weird%20and%20absurd%20cartoon%20anime%20creatures%20doing%20silly%20poses%2C%20colorful%20warm%20background%2C%20flat%20vector%20nonsense%20comedy%20style%2C%20playful%20chaotic%20energy&width=800&height=600&seq=xgkp-cat-02&orientation=landscape",
  },
  {
    key: "解压日常",
    title: "解压日常",
    desc: "轻节奏日常番，吃饭睡觉看番两不误，治愈疲惫身心，看完心情舒畅的解压番剧。",
    icon: "ri-cup-line",
    img: "https://readdy.ai/api/search-image?query=Cozy%20cartoon%20anime%20scene%20of%20relaxing%20at%20home%20with%20tea%20and%20tv%2C%20warm%20cream%20background%2C%20flat%20vector%20slice%20of%20life%20style%2C%20calm%20soothing%20mood&width=800&height=600&seq=xgkp-cat-03&orientation=landscape",
  },
  {
    key: "治愈番",
    title: "治愈番",
    desc: "暖心情节治愈系，萌宠与日常相伴，看完心里暖暖的，解压又治愈的宝藏番剧。",
    icon: "ri-heart-line",
    img: "https://readdy.ai/api/search-image?query=Heartwarming%20cartoon%20anime%20scene%20with%20a%20cute%20dog%20and%20blooming%20flowers%20under%20warm%20sunlight%2C%20soft%20cream%20and%20orange%20palette%2C%20flat%20vector%20healing%20style%2C%20tender%20gentle%20mood&width=800&height=600&seq=xgkp-cat-04&orientation=landscape",
  },
];